import taxlab_logo from "../../../assets/images/taxlab.png";

export default function TaxlabLogo() {
    const configuredLogo =
        (typeof window !== "undefined" && window.brandLogoUrl) || "";
    const logoSrc = configuredLogo || taxlab_logo;

    return (
        <img src={logoSrc} alt="Taxlab" />
    );
};

